import { useState } from "react";
import { CATEGORY_COLORS, QUIZ_QUESTIONS, PREFECTURES } from "../data/subsidies";
import { TIMEREX_URL, EXPERT, lineEntryUrl } from "../config";
import { useApi } from "../hooks/useApi";
import { useSubsidies } from "../hooks/useSubsidies";

// ── Bakrin プロモーションバナー ──────────────────────
function BakrinBanner() {
  return (
    <div style={bS.wrap}>
      <div style={bS.header}>
        <span style={bS.logo}>🌾 Bakrin</span>
        <span style={bS.tag}>📢 キャンペーン中</span>
      </div>
      <h3 style={bS.headline}>あなただけの新たな市場、<br />開拓しませんか？</h3>
      <div style={bS.videoWrap}>
        <iframe
          src="https://www.youtube.com/embed/aTARPjqPKuk"
          style={bS.video}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Bakrin紹介動画"
        />
      </div>
      <div style={bS.box}>
        <p style={bS.boxText}>
          🎉 現在キャンペーン中につき<br />
          <strong style={bS.free}>永年手数料無料！！</strong>
        </p>
        <p style={bS.note}>登録料・年会費・月額費用は無料</p>
      </div>
      <div style={bS.btns}>
        <a href="https://bakrin.no-yen.com/lp/" target="_blank" rel="noreferrer" style={bS.sub}>
          🌐 Bakrinを詳しく見る
        </a>
        <a href="https://bakrin.no-yen.com/signed_up/step1" target="_blank" rel="noreferrer" style={bS.cta}>
          無料で登録する →
        </a>
      </div>
    </div>
  );
}
const mL = {
  "◎": { background:"#e8f5e9", color:"#2e7d32", fontWeight:700, fontSize:"0.76rem", padding:"0.15rem 0.55rem", borderRadius:99, whiteSpace:"nowrap" },
  "○": { background:"#e3f2fd", color:"#1565c0", fontWeight:700, fontSize:"0.76rem", padding:"0.15rem 0.55rem", borderRadius:99, whiteSpace:"nowrap" },
  "△": { background:"#fff3e0", color:"#e65100", fontWeight:700, fontSize:"0.76rem", padding:"0.15rem 0.55rem", borderRadius:99, whiteSpace:"nowrap" },
};
const bS = {
  wrap:     { background:"linear-gradient(135deg,#1a4a2e,#2d6a4f)", borderRadius:14, padding:"1.25rem", margin:"1.25rem 0", color:"#fff", boxShadow:"0 4px 20px rgba(26,74,46,.35)" },
  header:   { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"0.6rem" },
  logo:     { fontSize:"0.9rem", fontWeight:700, color:"#a7f3c0" },
  tag:      { fontSize:"0.72rem", background:"#f59e0b", color:"#fff", borderRadius:99, padding:"0.2rem 0.7rem", fontWeight:700 },
  headline: { fontSize:"1.1rem", fontWeight:800, lineHeight:1.55, marginBottom:"0.9rem", color:"#fff" },
  videoWrap:{ position:"relative", width:"100%", paddingTop:"56.25%", marginBottom:"0.9rem", borderRadius:8, overflow:"hidden", background:"#000" },
  video:    { position:"absolute", top:0, left:0, width:"100%", height:"100%", borderRadius:8 },
  box:      { background:"rgba(255,255,255,.12)", borderRadius:10, padding:"0.75rem", textAlign:"center", marginBottom:"0.9rem" },
  boxText:  { fontSize:"0.95rem", lineHeight:1.7, color:"#fff" },
  free:     { fontSize:"1.3rem", color:"#fde68a", display:"block", marginTop:"0.2rem" },
  note:     { fontSize:"0.75rem", color:"#a7f3c0", marginTop:"0.3rem" },
  btns:     { display:"flex", flexDirection:"column", gap:"0.5rem" },
  sub:      { display:"block", textAlign:"center", background:"rgba(255,255,255,.15)", color:"#fff", fontWeight:600, fontSize:"0.88rem", borderRadius:10, padding:"0.65rem", textDecoration:"none", border:"1px solid rgba(255,255,255,.3)" },
  cta:      { display:"block", textAlign:"center", background:"#fff", color:"#1a4a2e", fontWeight:800, fontSize:"0.95rem", borderRadius:10, padding:"0.85rem", textDecoration:"none", boxShadow:"0 2px 8px rgba(0,0,0,.2)" },
};

// ── ヘルパー ──────────────────────────────────────
// ── 専門用語解説 ──────────────────────────────────
const TERMS = {
  "認定農業者": "市区町村に「農業経営改善計画」を提出して認定を受けた農業者のこと。多くの補助金の申請要件になっている。取得に約1〜3ヶ月かかる。",
  "認定新規就農者": "就農後5年以内の農業者が市区町村に「青年等就農計画」を提出して認定を受けたもの。就農支援系補助金の要件になることが多い。",
  "gBizID": "法人や個人事業主が国の行政サービスを使うための共通IDのこと。多くの補助金のオンライン申請に必要。取得に2〜3週間かかる。",
  "事前着手": "補助金の採択・交付決定が出る前に、工事・購入・契約を開始すること。ほとんどの補助金で事前着手は「対象外」になり採択されても補助金を受け取れない。",
  "青色申告": "農業収入・経費を帳簿に記録して確定申告する方式。収入保険・所得安定系補助金の要件になることが多い。税務上のメリットもある。",
  "地域計画": "市区町村が農地の将来の利用方法を定めた計画のこと。「人・農地プラン」とも呼ばれる。設備投資系補助金で要件になることがある。",
  "採択率": "申請した補助金のうち、採択（認められた）割合のこと。人気の補助金は採択率が低くなる傾向がある。",
  "補助率": "補助金がカバーする割合のこと。「補助率1/2」なら、100万円の投資に対して50万円が補助される。",
  "JAバンク": "農業協同組合（農協）が運営する金融機関のこと。農業融資の窓口になることが多い。",
  "成功報酬": "補助金が採択されたときだけ行政書士報酬を支払う仕組み。採択されなければ費用ゼロになる場合が多い。",
};

// 申請タイムライン（カテゴリ別・おおよその目安）
const TIMELINE = {
  設備投資:    ["📋 今すぐ：認定農業者の申請（未取得の場合・約1〜3ヶ月）", "📄 申請月：見積書・事業計画書の作成", "✅ 申請後2〜4ヶ月：採択通知", "🚜 採択後：機械・施設の発注・購入（事前着手禁止）", "📊 事業完了後：実績報告書の提出"],
  就農支援:    ["📋 今すぐ：認定新規就農者の申請（未取得の場合）", "🏛️ 市町村農政課に相談（申請用紙取得）", "✅ 申請後1〜2ヶ月：採択通知", "💰 採択後：資金の交付開始"],
  スマート農業:["📋 今すぐ：導入計画の作成・スマート機器の選定", "📄 申請前：実証計画書・見積書の作成", "✅ 申請後2〜4ヶ月：採択通知", "🤖 採択後：機器の発注・導入（事前着手禁止）"],
  "6次産業化": ["📋 今すぐ：6次産業化計画の認定申請（約2〜4ヶ月）", "🤝 販路先・加工業者との連携協議", "✅ 申請後2〜4ヶ月：採択通知", "🏭 採択後：施設の建設・機器導入（事前着手禁止）"],
  収入安定:    ["📋 今すぐ：農業共済（NOSAI）に加入", "✅ 加入後：翌年1月から保険期間スタート（収入保険の場合）"],
  融資:        ["📋 今すぐ：農協または政策公庫に相談", "📄 審査書類の作成（経営改善計画等）", "✅ 審査後1〜2ヶ月：融資実行"],
  環境対応:    ["📋 今すぐ：化学肥料・農薬削減計画の作成", "🏛️ 市町村農政課への事前確認", "✅ 毎年4〜5月頃：申請受付"],
  輸出支援:    ["📋 今すぐ：GFP（農林水産物輸出プロジェクト）への登録", "📄 GAP認証の取得（約3〜6ヶ月）", "✅ 申請後2〜4ヶ月：採択通知"],
};

// 組み合わせ可能な補助金（カテゴリ別）
const COMBO_SUGGESTIONS = {
  設備投資:    ["✅ 県・市町村の機械施設整備補助金（経費を分ければ重複OK）", "✅ 融資制度（スーパーL資金等）との組み合わせで自己負担を最小化", "⚠️ 同一経費での複数補助金申請は不可"],
  スマート農業:["✅ 農水省のスマート農業補助 + 経産省IT導入補助金（経費を分ければOK）", "✅ 都道府県のスマート農業補助との組み合わせ可能な場合あり", "⚠️ 同一機器・ソフトへの重複申請は不可"],
  "6次産業化": ["✅ ものづくり補助金（経産省）との組み合わせ可能な場合あり", "✅ 農泊推進型交付金（農水省）との組み合わせ可能な場合あり"],
  就農支援:    ["✅ 融資制度（青年等就農資金）との組み合わせで手厚い支援に", "✅ 都道府県・市町村の独自就農支援との重複OK（条件確認要）"],
};

const NATIONAL_SOURCES = ['農林水産省','経済産業省','日本政策金融公庫','厚生労働省','環境省','内閣府'];

// 難易度（★〜★★★）
const DIFFICULTY = {
  収入安定:    { stars: 1, label: "★☆☆ 比較的簡単",   color: "#2e7d32" },
  就農支援:    { stars: 2, label: "★★☆ 中程度",       color: "#f57f17" },
  設備投資:    { stars: 2, label: "★★☆ 中程度",       color: "#f57f17" },
  融資:        { stars: 1, label: "★☆☆ 比較的簡単",   color: "#2e7d32" },
  スマート農業:{ stars: 3, label: "★★★ やや難しい",   color: "#c62828" },
  環境対応:    { stars: 2, label: "★★☆ 中程度",       color: "#f57f17" },
  "6次産業化": { stars: 3, label: "★★★ やや難しい",   color: "#c62828" },
  輸出支援:    { stars: 3, label: "★★★ やや難しい",   color: "#c62828" },
  税制優遇:    { stars: 1, label: "★☆☆ 比較的簡単",   color: "#2e7d32" },
  農福連携:    { stars: 2, label: "★★☆ 中程度",       color: "#f57f17" },
  農地活用:    { stars: 1, label: "★☆☆ 比較的簡単",   color: "#2e7d32" },
  経営支援:    { stars: 1, label: "★☆☆ 比較的簡単",   color: "#2e7d32" },
};

// カテゴリ別：採択率を上げるポイント
const BONUS_POINTS = {
  設備投資:    ["✅ 認定農業者の取得（最重要）", "✅ 地域計画（人・農地プラン）への位置づけ", "✅ 複数農家でのグループ申請", "✅ 農地集積率の向上実績"],
  就農支援:    ["✅ 認定新規就農者の認定を受ける", "✅ 青色申告への移行計画", "✅ 市町村の農業委員会との事前相談"],
  スマート農業:["✅ スマート農業技術活用促進法の認定", "✅ 実証データ・効果測定の準備", "✅ 農業支援サービス事業者との連携"],
  "6次産業化": ["✅ 6次産業化法の総合化事業計画の認定", "✅ 地元JA・農協との連携協定", "✅ 販路先の確保・MOU締結"],
  環境対応:    ["✅ 有機JAS認証の取得（または取得計画）", "✅ 化学肥料・農薬50%削減の実績・計画", "✅ 農業者グループへの参加"],
  収入安定:    ["✅ 農業共済（NOSAI）への加入", "✅ 青色申告の継続（1年以上）", "✅ 経営規模の基準確認"],
  輸出支援:    ["✅ GFP（農林水産物・食品輸出プロジェクト）への参画", "✅ GAP認証の取得", "✅ 輸出先バイヤーとのコンタクト実績"],
  融資:        ["✅ 認定農業者の取得", "✅ 農業経営改善計画の策定", "✅ 青色申告・帳簿管理の整備"],
  農福連携:    ["✅ 福祉事業者との連携協定の締結", "✅ 農福連携の取り組み実績", "✅ 市町村・都道府県への事前相談"],
  税制優遇:    ["✅ 青色申告の徹底", "✅ 認定農業者の取得", "✅ 経営力向上計画の認定（中小企業系）"],
  農地活用:    ["✅ 農地バンク（農地中間管理機構）への登録", "✅ 地域計画への位置づけ", "✅ 農地集積・集約化の実績"],
  経営支援:    ["✅ 認定農業者または認定新規就農者", "✅ 経営改善計画の策定", "✅ JAや農業経営アドバイザーへの相談実績"],
};

// 申請方法の分類（農協でOK / 自分で申請 / 行政書士推奨）
const APPLY_METHOD = {
  収入安定:    { level: "農協・NOSAI窓口でOK", color: "#2e7d32", icon: "🏢", desc: "農協や農業共済組合の窓口で手続きできます。" },
  融資:        { level: "農協・政策公庫窓口でOK", color: "#2e7d32", icon: "🏢", desc: "農協または日本政策金融公庫の窓口で相談できます。" },
  税制優遇:    { level: "税理士・自分で申請可", color: "#1565c0", icon: "📊", desc: "確定申告時に申請。税理士や会計士に相談することをお勧めします。" },
  農地活用:    { level: "市町村農業委員会窓口でOK", color: "#2e7d32", icon: "🏛️", desc: "市区町村の農業委員会・農政課に直接相談できます。" },
  就農支援:    { level: "市町村窓口でOK", color: "#2e7d32", icon: "🏛️", desc: "市区町村の農政課に相談できます。農協も対応しています。" },
  設備投資:    { level: "行政書士に依頼推奨", color: "#c62828", icon: "👨‍💼", desc: "事業計画書の作成が必要で複雑な手続きが多いため、行政書士のサポートをお勧めします。" },
  スマート農業:{ level: "行政書士に依頼推奨", color: "#c62828", icon: "👨‍💼", desc: "実証計画・導入計画の作成が必要です。行政書士のサポートをお勧めします。" },
  "6次産業化": { level: "行政書士に依頼推奨", color: "#c62828", icon: "👨‍💼", desc: "総合化事業計画の認定が必要で難度が高いため、行政書士のサポートをお勧めします。" },
  輸出支援:    { level: "行政書士に依頼推奨", color: "#c62828", icon: "👨‍💼", desc: "輸出計画書・GAP認証等が必要です。行政書士のサポートをお勧めします。" },
  環境対応:    { level: "市町村窓口・農協でOK", color: "#2e7d32", icon: "🏛️", desc: "市区町村農政課・農協で手続きできます。有機JAS認証は登録機関が必要です。" },
  農福連携:    { level: "市町村・県窓口でOK", color: "#1565c0", icon: "🏛️", desc: "市区町村・都道府県の農政担当課と福祉担当課に相談してください。" },
  経営支援:    { level: "農業経営アドバイザー・農協でOK", color: "#2e7d32", icon: "🤝", desc: "農業経営アドバイザーや農協の経営相談窓口で対応できます。" },
};

// 書類の多さ
const DOC_VOLUME = {
  収入安定: "少", 融資: "少", 税制優遇: "少", 農地活用: "中",
  就農支援: "中", 環境対応: "中", 農福連携: "中", 経営支援: "少",
  設備投資: "多", スマート農業: "多", "6次産業化": "多", 輸出支援: "多",
};

const DOC_COLOR = { 少: "#2e7d32", 中: "#f57f17", 多: "#c62828" };

// 「今すぐやること」TODOリスト（カテゴリ別）
const TODO_LIST = {
  設備投資:    ["📌 購入前に必ず申請する（事前着手禁止）", "📋 見積書を複数社から取得する", "🏛️ 市町村農政課・農林事務所に事前相談", "📄 認定農業者の資格を確認・取得", "🤝 行政書士に事業計画書の作成を相談"],
  就農支援:    ["📋 認定新規就農者の認定を市町村に申請", "📊 青色申告への移行手続きを開始", "🏛️ 市町村の農業委員会に事前相談", "📝 就農計画書を作成する"],
  スマート農業:["📌 購入前に必ず申請する（事前着手禁止）", "📄 スマート農業導入計画の作成", "🏛️ 都道府県農政部・農林事務所に相談", "🤝 農業支援サービス事業者との連携検討"],
  "6次産業化": ["📋 6次産業化法の計画認定を申請", "🤝 地元JAや食品加工業者との連携協議", "📌 購入・工事前に申請する（事前着手禁止）", "🤝 行政書士に計画書の作成を相談"],
  環境対応:    ["📊 化学肥料・農薬の使用量を記録する", "📋 有機農業への転換計画を作成", "🏛️ 市町村農政課に事前確認", "🤝 農業者グループへの参加を検討"],
  収入安定:    ["📋 農業共済（NOSAI）に加入する", "📊 青色申告を開始する（まだの場合）", "🏛️ 市町村の農業委員会・農林事務所に相談"],
  輸出支援:    ["🌐 GFP（農林水産物輸出プロジェクト）に登録", "📋 GAP認証の取得を検討・申請", "🤝 輸出商社・バイヤーとのコンタクト", "🤝 行政書士に輸出計画書の作成を相談"],
  融資:        ["🏦 日本政策金融公庫・農協に相談", "📊 農業経営改善計画の作成", "📋 認定農業者の申請（未取得の場合）"],
  農福連携:    ["🤝 地域の福祉事業者（就労継続支援B型等）に相談", "📋 農福連携の実施計画を作成", "🏛️ 市町村・都道府県に事前相談"],
  税制優遇:    ["📊 青色申告を徹底する", "📋 中小企業経営強化計画の認定を申請", "🏦 税理士・会計士に節税効果を相談"],
  農地活用:    ["🏛️ 農地バンク（農地中間管理機構）に登録", "📋 地域計画（人・農地プラン）への位置づけを確認", "🏛️ 市町村農業委員会に相談"],
  経営支援:    ["📊 農業経営改善計画を作成", "🏛️ 最寄りの農業経営アドバイザーに相談", "📋 認定農業者の申請（未取得の場合）"],
};

// 県・市町村の制度を先に見せる分類。
// 設備・就農・農地・環境の制度は、国の制度が自治体におりて別の名前で募集されることが多く、
// 地元の制度から先に確認するのが早い（行政書士の実務の順番）。それ以外（スマート農業など）は国の制度の幅が広い。
const LOCAL_FIRST_CATEGORIES = ["設備投資", "就農支援", "農地活用", "環境対応"];

const isNational = (s) => !s.source || NATIONAL_SOURCES.includes(s.source);

// 地域（県・市町村）は一度入れたら端末に覚えておく
const PROFILE_KEY = "nouen_profile";
const loadProfile = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(PROFILE_KEY));
    return saved && typeof saved === "object" ? saved : {};
  } catch {
    return {};
  }
};

// ホームで選ぶ「やりたいこと」（分類）→ 診断の purpose 選択肢。対応があれば診断でこの質問を省く
const GOAL_PURPOSE = {
  設備投資:     "農機・ハウス・設備を新しく買いたい",
  収入安定:     "天候や価格変動で収入が不安定",
  就農支援:     "農業を始めたばかり・お金が足りない",
  環境対応:     "農薬を減らして有機農業に転換したい",
  スマート農業: "ドローン・スマート農業を導入したい",
  "6次産業化":  "加工・直売・農家レストランを始めたい",
  農地活用:     "農地を広げて規模拡大したい",
  輸出支援:     "農産物を海外に売りたい",
  税制優遇:     "節税・税金対策をしたい",
  経営支援:     "経営の専門家に相談したい",
  農福連携:     "障がい者・多様な人と農業をしたい",
};

const quizOptions = (id) => (QUIZ_QUESTIONS.find((q) => q.id === id) || {}).options || [];

// 都道府県を選ぶ＋市町村を書く（細かい住所は聞かない）
function PrefFields({ value, onChange }) {
  return (
    <>
      <select
        className="field-input"
        value={value.pref || ""}
        onChange={(e) => onChange({ ...value, pref: e.target.value })}
      >
        <option value="">都道府県を選ぶ</option>
        {PREFECTURES.map((p) => <option key={p} value={p}>{p}</option>)}
      </select>
      <input
        className="field-input"
        placeholder="市町村（例：帯広市）※わかる範囲で"
        value={value.city || ""}
        onChange={(e) => onChange({ ...value, city: e.target.value })}
      />
    </>
  );
}

// 補助金1件のカード（一覧・診断結果で共通）
function SubsidyCard({ s, onOpen }) {
  const c = CATEGORY_COLORS[s.category] || {};
  return (
    <div className="subsidy-card" onClick={() => onOpen(s)}>
      <div className="subsidy-row">
        <span className="subsidy-icon">{s.icon}</span>
        <div className="subsidy-info">
          <div className="subsidy-name">{s.name}</div>
          <div className="subsidy-sub">{s.maxAmount}</div>
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:"0.25rem", alignItems:"flex-end" }}>
          {s.matchLabel && <span style={mL[s.matchLabel]}>{s.matchLabel}</span>}
          <span className="badge" style={{ background: c.bg, color: c.text }}>{s.category}</span>
        </div>
      </div>
      {s.source && s.source !== "農林水産省" && (
        <div style={{ fontSize:"0.72rem", color:"#888", marginTop:"0.2rem" }}>📌 {s.source}</div>
      )}
      <p className="subsidy-desc">{s.summary}</p>
    </div>
  );
}

// 制度がたくさん出て迷う人のための分かれ道。「すぐ相談」と「自分で絞る」を最初から並べる
function ConsultPaths({ title, onQuick, secondLabel, secondNote, onSecond }) {
  return (
    <div style={{ background:"#f1f8e9", border:"1px solid #aed581", borderRadius:12, padding:"0.9rem", marginBottom:"0.9rem" }}>
      <div style={{ fontWeight:700, fontSize:"0.85rem", color:"#33691e", marginBottom:"0.6rem" }}>{title}</div>
      <button
        onClick={onQuick}
        style={{ display:"block", width:"100%", background:"#2e7d32", color:"#fff", fontWeight:800, fontSize:"0.93rem", borderRadius:10, padding:"0.8rem", border:"none", cursor:"pointer", marginBottom:"0.25rem" }}
      >
        👨‍💼 専門家に無料で相談する
      </button>
      <div style={{ fontSize:"0.7rem", color:"#666", textAlign:"center", marginBottom:"0.6rem" }}>入力はほぼ不要。合う制度を専門家が一緒に探します</div>
      <button
        onClick={onSecond}
        style={{ display:"block", width:"100%", background:"#fff", color:"#2e7d32", fontWeight:700, fontSize:"0.9rem", borderRadius:10, padding:"0.7rem", border:"2px solid #2e7d32", cursor:"pointer", marginBottom:"0.25rem" }}
      >
        {secondLabel}
      </button>
      <div style={{ fontSize:"0.7rem", color:"#666", textAlign:"center" }}>{secondNote}</div>
    </div>
  );
}

// 相談先の専門家の紹介。名前・写真・実績は設定（config.js）に入っているものだけ出す
function ExpertCard() {
  return (
    <div style={{ display:"flex", gap:"0.75rem", alignItems:"flex-start", background:"#fff", border:"1px solid #e0e0e0", borderRadius:12, padding:"0.85rem", marginBottom:"0.75rem" }}>
      {EXPERT.photo
        ? <img src={EXPERT.photo} alt={EXPERT.name} style={{ width:56, height:56, borderRadius:"50%", objectFit:"cover", flexShrink:0 }} />
        : <span style={{ fontSize:"2.2rem", lineHeight:1 }}>👨‍💼</span>}
      <div style={{ minWidth:0 }}>
        <div style={{ fontWeight:800, fontSize:"0.92rem", color:"#1a4a2e" }}>
          {EXPERT.name ? `${EXPERT.name}${EXPERT.title ? `（${EXPERT.title}）` : ""}` : "提携行政書士"}
        </div>
        {EXPERT.office && <div style={{ fontSize:"0.76rem", color:"#666" }}>{EXPERT.office}</div>}
        {EXPERT.achievements.map((a, i) => (
          <div key={i} style={{ fontSize:"0.78rem", color:"#444", marginTop:"0.15rem" }}>・{a}</div>
        ))}
        {EXPERT.site && (
          <a href={EXPERT.site} target="_blank" rel="noreferrer" style={{ fontSize:"0.76rem", color:"#1565c0" }}>事務所のページを見る</a>
        )}
        <div style={{ fontSize:"0.74rem", color:"#666", marginTop:"0.3rem", lineHeight:1.6 }}>
          制度を1つに決めていなくても大丈夫です。やりたいことを聞いて、国・県・市町村の制度から合うものを一緒に探します。
        </div>
      </div>
    </div>
  );
}

// キーは QUIZ_QUESTIONS の purpose 選択肢と完全一致させること（不一致だと目的の配点30点が常に0になる）
const MATCH_PURPOSE_MAP = {
  "農機・ハウス・設備を新しく買いたい":   ["設備投資", "融資"],
  "天候や価格変動で収入が不安定":         ["収入安定"],
  "農業を始めたばかり・お金が足りない":   ["就農支援", "融資"],
  "ドローン・スマート農業を導入したい":   ["スマート農業", "設備投資"],
  "農薬を減らして有機農業に転換したい":   ["環境対応"],
  "加工・直売・農家レストランを始めたい": ["6次産業化"],
  "農産物を海外に売りたい":               ["輸出支援"],
  "節税・税金対策をしたい":               ["税制優遇"],
  "農地を広げて規模拡大したい":           ["農地活用", "設備投資", "融資"],
  "経営の専門家に相談したい":             ["経営支援"],
  "障がい者・多様な人と農業をしたい":     ["農福連携"],
};

// 診断の main_crop 選択肢 → 補助金データの crops 表記への対応表
const CROP_MATCH_MAP = {
  "水稲・米":           ["水田", "水稲・米"],
  "野菜（露地）":       ["野菜", "野菜（露地）"],
  "野菜（施設）":       ["野菜", "野菜（施設）"],
  "果樹":               ["果樹"],
  "畑作（麦・大豆・いも等）":     ["畑作"],
  "畜産（肉用牛・養豚・養鶏）":   ["畜産"],
  "酪農":                         ["畜産", "酪農"],
  // "その他・複合経営" は判定不能のため中間点扱い
};

// 事前着手（契約・購入済み）だと原則対象外になる投資系カテゴリ
const PRE_CONTRACT_NG_CATEGORIES = ["設備投資", "スマート農業", "6次産業化", "輸出支援"];

function scoreSubsidies(answers, subsidies) {
  return subsidies
    .map((s) => {
      let score = 0;
      let maxScore = 0;
      const checks = []; // 「なぜこの相性か」の内訳（結果画面で表示）

      // 経営形態（30点）
      if (answers.farmer_type) {
        maxScore += 30;
        const hit = s.target.some((t) =>
          answers.farmer_type.includes(t) ||
          (t === "新規就農者" && answers.farmer_type.includes("新規就農者")) ||
          (t === "就農予定（まだ農業をしていない）" && answers.farmer_type.includes("就農予定"))
        );
        if (hit) score += 30;
        checks.push({ t: "経営のかたち（個人・法人など）", ok: hit ? "◎" : "△" });
      }

      // 目的（30点）
      if (answers.purpose) {
        maxScore += 30;
        const cats = MATCH_PURPOSE_MAP[answers.purpose] || [];
        const hit = cats.includes(s.category);
        if (hit) score += 30;
        checks.push({ t: "やりたいこととの一致", ok: hit ? "◎" : "△" });
      }

      // 年齢（15点）—— 就農支援系は年齢制限あり
      if (answers.age_range) {
        maxScore += 15;
        const isYoung  = answers.age_range === "39歳以下";
        const isMid    = answers.age_range === "40〜49歳";
        const isSenior = ["50〜64歳", "65歳以上"].includes(answers.age_range);
        if (s.category === "就農支援") {
          if (isYoung)  score += 15;
          else if (isMid) score += 8;
          // 50歳以上は就農支援系のスコアなし（ただし除外はしない）
          checks.push({ t: "年齢（若手向けの制度です）", ok: isYoung ? "◎" : isMid ? "○" : "△" });
        } else {
          score += 15; // 年齢制限のない補助金は全員満点
        }
      }

      // 認定資格（15点）
      if (answers.certification) {
        maxScore += 15;
        const isCertified    = answers.certification === "認定農業者（市町村に認定済み）";
        const isNewFarmerCert = answers.certification === "認定新規就農者";
        if (["設備投資", "融資", "スマート農業", "収入安定"].includes(s.category)) {
          // 認定農業者が要件の多いカテゴリ
          if (isCertified) score += 15;
          else if (isNewFarmerCert) score += 8;
          else score += 3;
          checks.push({ t: "認定農業者などの資格", ok: isCertified ? "◎" : isNewFarmerCert ? "○" : "△" });
        } else if (s.category === "就農支援") {
          if (isNewFarmerCert) score += 15;
          else if (isCertified) score += 5;
          else score += 3;
          checks.push({ t: "認定新規就農者の資格", ok: isNewFarmerCert ? "◎" : "△" });
        } else {
          score += 15; // 資格不問の補助金
        }
      }

      // 作物（15点）—— 対象作物が合っているか
      if (answers.main_crop) {
        maxScore += 15;
        const isAllCrops = !s.crops || s.crops.includes("全作目");
        const cropKeys = CROP_MATCH_MAP[answers.main_crop];
        if (isAllCrops) score += 15;                     // 全作目対象
        else if (!cropKeys) { score += 8; checks.push({ t: "作物との相性", ok: "○" }); }
        else if (s.crops.some((c) => cropKeys.some((k) => c.includes(k)))) { score += 15; checks.push({ t: "作物との相性", ok: "◎" }); }
        else { score += 2; checks.push({ t: "作物との相性（対象外の可能性）", ok: "△" }); }
      }

      // 青色申告（10点）—— 要件に青色申告がある補助金の適合度
      if (answers.blue_tax) {
        maxScore += 10;
        const needsBlueTax = s.requirements?.some((r) => r.includes("青色申告"));
        if (!needsBlueTax) score += 10;                  // 青色申告不問
        else if (answers.blue_tax === "はい、青色申告しています") { score += 10; checks.push({ t: "青色申告（この制度の要件）", ok: "◎" }); }
        else if (answers.blue_tax === "まだ確定申告していない（新規就農予定）") { score += 5; checks.push({ t: "青色申告（移行計画が必要）", ok: "○" }); } // 移行計画で可の場合あり
        else { score += 2; checks.push({ t: "青色申告（白色のままでは要件未達）", ok: "△" }); } // 白色申告のままでは要件未達
      }

      // 経験年数（10点）—— 就農支援系は就農間もない人が対象
      if (answers.farm_experience) {
        maxScore += 10;
        if (s.category === "就農支援") {
          if (["就農1年未満（これから）", "1〜3年（新規就農期）"].includes(answers.farm_experience)) score += 10;
          else if (answers.farm_experience === "4〜9年") score += 4; // 就農5年以内まで対象の制度あり
          // 10年以上は就農支援系のスコアなし（除外はしない）
        } else {
          score += 10; // 経験年数を問わない補助金
        }
      }

      // 農地面積（5点）—— 規模感でフィルタリング補正
      if (answers.farm_size) {
        maxScore += 5;
        const isLarge = ["5〜10ha", "10ha以上（大規模）"].includes(answers.farm_size);
        const isSmall = answers.farm_size === "1ha未満（小規模）";
        if (["経営支援"].includes(s.category) && isSmall) score += 5;
        else if (["設備投資", "農地活用"].includes(s.category) && isLarge) score += 5;
        else score += 3; // どの規模でも一定のスコア
      }

      // 地域（10点）—— 中山間地域限定 × 非対象 → 除外
      if (answers.region) {
        maxScore += 10;
        const isNational = !s.regions || s.regions.includes("全国");
        const isMountainOnly = s.regions?.includes("中山間地域") && !isNational;
        if (isMountainOnly && answers.region !== "中山間地域（山間部・傾斜地）") return null;
        if (isNational || (isMountainOnly && answers.region === "中山間地域（山間部・傾斜地）")) score += 10;
      }

      // 鳥獣被害（10点）—— wildlifeOnly × 被害なし → 除外
      if (answers.wildlife_damage) {
        maxScore += 10;
        if (s.wildlifeOnly) {
          if (answers.wildlife_damage !== "被害を受けている") return null;
          score += 10;
        } else {
          score += 10;
        }
      }

      // 栽培品目 —— 制度の名前・説明・要件にその品目が出てくれば加点（出てこなくても減点はしない）
      if (answers.crop_items) {
        const items = answers.crop_items.split(/[、,，・\s/]+/).map((t) => t.trim()).filter((t) => t.length >= 2);
        const hay = [s.name, s.summary, ...(s.requirements || []), ...(s.crops || [])].join(" ");
        const hitItem = items.find((t) => hay.includes(t));
        if (hitItem) {
          maxScore += 10;
          score += 10;
          checks.push({ t: `栽培品目「${hitItem}」が制度の説明に出てきます`, ok: "◎" });
        }
      }

      // 県の制度：選んだ県と違う県のものは出さない（県が未入力なら全部出す）
      if (!isNational(s) && answers.prefecture && s.source !== answers.prefecture) {
        return null;
      }

      let pct = maxScore > 0 ? Math.round((score / maxScore) * 100) : 50;

      // 契約・発注済み × 投資系補助金 → 原則「事前着手」で対象外のため警告＋大幅減点（除外はしない）
      const contractWarning =
        answers.contract_status === "すでに契約・発注・購入済み" &&
        PRE_CONTRACT_NG_CATEGORIES.includes(s.category);
      if (contractWarning) {
        pct = Math.min(pct, 30);
        checks.unshift({ t: "契約・購入の前であること（事前着手のきまり）", ok: "△" });
      }

      return {
        ...s,
        matchScore: pct,
        matchLabel: pct >= 80 ? "◎" : pct >= 50 ? "○" : "△",
        contractWarning,
        checks,
      };
    })
    .filter(Boolean)
    // 相性が同じなら、県の制度を国の制度より先に
    .sort((a, b) => b.matchScore - a.matchScore || (isNational(a) - isNational(b)));
}

// ── 画面コンポーネント ────────────────────────────
export default function SubsidyScreen({ goal = null, startPref = "", onChangeGoal }) {
  // 地域（県・市町村）。URLで県が渡されたらそれを優先する
  const [profile, setProfile] = useState(() => {
    const saved = loadProfile();
    if (!startPref || saved.pref === startPref) return saved;
    return { ...saved, pref: startPref, city: "" };
  });
  // やりたいことを選んで来たのに地域がまだなら、先に県・市町村を聞く（「あとで」を選んだ人には繰り返し聞かない）
  const [phase,      setPhase]      = useState(goal && !profile.pref && !profile.asked ? "where" : "list");
  const [answers,    setAnswers]    = useState({});
  const [quizQueue,  setQuizQueue]  = useState([]);   // これから聞く質問のid（答えが分かっているものは省く）
  const [currentQ,   setCurrentQ]  = useState(0);
  const [textDraft,  setTextDraft] = useState("");
  const [whereDraft, setWhereDraft] = useState({ pref: profile.pref || "", city: profile.city || "" });
  const [matched,    setMatched]    = useState([]);
  const [selected,   setSelected]  = useState(null);
  const [openTerm,   setOpenTerm]  = useState(null);
  const [filter,     setFilter]    = useState(goal ? goal.category : "すべて");
  const [applyStep,  setApplyStep] = useState(0);
  const [applyData,  setApplyData] = useState({});
  const [doc,        setDoc]       = useState("");
  const [showAll,    setShowAll]    = useState(false);
  const [consultMode,  setConsultMode]  = useState("quick"); // quick＝かんたん相談 ／ detail＝くわしく相談
  const [consultBack,  setConsultBack]  = useState("list");
  const [consultQueue, setConsultQueue] = useState([]);
  const [consultStep, setConsultStep] = useState(0);
  const [consultData, setConsultData] = useState({});
  const [consultSheet, setConsultSheet] = useState("");
  const [sheetCopied, setSheetCopied] = useState(false);
  const [aiReco, setAiReco] = useState("");
  const { call, loading } = useApi();

  const saveProfile = (next) => {
    setProfile(next);
    try { localStorage.setItem(PROFILE_KEY, JSON.stringify(next)); } catch { /* 保存できなくても画面は進める */ }
  };
  const whereText = profile.pref ? `${profile.pref}${profile.city || ""}` : "";

  // 診断の回答を文章にする（県の質問は市町村も添える）
  const answerText = (q) => (q.id === "prefecture" ? `${answers.prefecture}${answers.city || ""}` : answers[q.id]);
  const esc = (v) => String(v).replace(/[&<>"]/g, (ch) => ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;" }[ch]));

  // 窓口持参シート: 診断結果をA4印刷用に別ウィンドウで開く（役場・JA窓口にそのまま持参できる）
  const printSheet = () => {
    const top = matched.slice(0, 5);
    const ansRows = QUIZ_QUESTIONS
      .filter((q) => answers[q.id])
      .map((q) => `<tr><td>${esc(q.question.replace(/？$/, ""))}</td><td>${esc(answerText(q))}</td></tr>`).join("");
    const subRows = top.map((s, i) =>
      `<tr><td>${i + 1}</td><td><b>${s.name}</b><br><small>${s.summary}</small></td><td>${s.maxAmount}</td><td>${s.deadline}</td></tr>`).join("");
    const w = window.open("", "_blank");
    w.document.write(`<!DOCTYPE html><html lang="ja"><head><meta charset="utf-8"><title>補助金相談シート</title>
<style>body{font-family:"Hiragino Sans",sans-serif;font-size:10.5pt;margin:24px;color:#222}
h1{font-size:15pt;border-bottom:2px solid #2d6a4f;padding-bottom:6px;color:#1a4a2e}
h2{font-size:11.5pt;color:#1a4a2e;margin:14px 0 6px}
table{border-collapse:collapse;width:100%;font-size:9pt}td,th{border:1px solid #999;padding:4px 8px;text-align:left;vertical-align:top}
.foot{margin-top:16px;font-size:8pt;color:#777;border-top:1px solid #ccc;padding-top:6px}</style></head><body>
<h1>🌾 補助金相談シート（窓口持参用）</h1>
<p>このシートは農家向けアプリ「農援」の診断結果です。窓口でのご相談にお使いください。（作成日: ${new Date().toLocaleDateString("ja-JP")}）</p>
<h2>1. わたしの状況（診断の回答）</h2><table>${ansRows}</table>
<h2>2. 相談したい補助金（相性の高い順）</h2><table><tr><th>#</th><th>制度名</th><th>金額の目安</th><th>募集時期</th></tr>${subRows}</table>
<p style="font-size:9pt">※金額・時期は年度により変わります。最新の公募要領をご確認ください。</p>
<div class="foot">農援株式会社 ─ 農家の心強い味方 ／ 補助金診断・かんたん帳簿・農地管理の無料アプリ ／ 近所の農家さん同士で余ったモノを交換できる「Bakrin」も準備中です</div>
<script>window.onload = () => window.print();<\/script></body></html>`);
    w.document.close();
  };

  // 診断結果の上位候補について、AIに「おすすめ理由」を書いてもらう
  const getAiReco = async () => {
    const top = matched.slice(0, 3);
    let fields = [];
    try {
      const saved = JSON.parse(localStorage.getItem("nouen_fields"));
      if (Array.isArray(saved)) fields = saved;
    } catch { /* 圃場未登録なら空のまま */ }
    const text = await call({
      maxTokens: 900,
      system: "あなたは農業補助金に詳しいアドバイザーです。断定的な採択保証はせず、金額・要件は年度で変わるため公式情報の確認を促してください。",
      messages: [{
        role: "user",
        content: `農家さんの診断結果です。
【回答】${QUIZ_QUESTIONS.map((q) => answers[q.id] ? `${q.question.replace(/？$/, "")}→${answerText(q)}` : "").filter(Boolean).join("／")}
${fields.length ? `【登録済みの圃場】${fields.map((f) => `${f.name}(${f.area}a・${f.crop})`).join("、")}` : ""}
【マッチした上位候補】
${top.map((s, i) => `${i + 1}. ${s.name}（${s.category}）：${s.summary}`).join("\n")}

この方に向けて、上位候補それぞれについて「なぜあなたにおすすめか」を1〜2文で、農家さんに話しかける平易な言葉で書いてください。最後に、最初の一歩（どこに相談するか）を1文添えてください。全体で300字程度。`,
      }],
    });
    setAiReco(text);
  };
  const { subsidies: SUBSIDIES, loading: dataLoading } = useSubsidies();

  if (dataLoading) return <div className="screen" style={{ textAlign:"center", paddingTop:"3rem" }}>補助金データを読み込み中...</div>;

  // 県が分かっていれば、ほかの県の制度は出さない（国の制度＋その県の制度だけにする）
  const visible = SUBSIDIES.filter((s) => isNational(s) || !profile.pref || s.source === profile.pref);
  const catSet = [...new Set(visible.map((s) => s.category))];
  const cats = ["すべて", ...(goal ? [goal.category, ...catSet.filter((c) => c !== goal.category)] : catSet)];
  const filtered = filter === "すべて" ? visible : visible.filter((s) => s.category === filter);
  const localList    = profile.pref ? filtered.filter((s) => !isNational(s)) : [];
  const nationalList = profile.pref ? filtered.filter(isNational) : filtered;
  const openDetail = (s) => { setSelected(s); setPhase("detail"); };

  const APPLY_FIELDS = [
    { label: "氏名または法人名", key: "name",    ph: "例：田中 太郎" },
    { label: "住所",             key: "address", ph: "例：北海道〇〇市〇〇町" },
    { label: "農業規模",         key: "scale",   ph: "例：水稲5ha、野菜2ha" },
    { label: "申請したい用途",   key: "purpose", ph: "例：トラクターの購入" },
    { label: "概算費用",         key: "cost",    ph: "例：500万円" },
  ];

  // ── 診断の進行 ──
  const showResults = (ans) => {
    setMatched(scoreSubsidies(ans, SUBSIDIES));
    setAiReco("");
    setShowAll(false);
    setPhase("results");
  };

  // stage "core"＝最初の数問で一度結果を出す ／ "more"＝結果画面から残りの質問に答えてさらに絞る
  const startQuiz = (stage) => {
    const pre = stage === "core" ? {} : { ...answers };
    if (profile.pref) { pre.prefecture = profile.pref; pre.city = profile.city || ""; }
    if (goal && GOAL_PURPOSE[goal.category] && !pre.purpose) pre.purpose = GOAL_PURPOSE[goal.category];
    const queue = QUIZ_QUESTIONS
      .filter((q) => (stage === "core") === !!q.core && !pre[q.id])
      .map((q) => q.id);
    setAnswers(pre);
    setQuizQueue(queue);
    setCurrentQ(0);
    setTextDraft("");
    setSelected(null);
    if (queue.length === 0) showResults(pre);
    else setPhase("quiz");
  };

  // patch＝その質問で分かったこと（スキップなら空）
  const handleAnswer = (patch) => {
    const next = { ...answers, ...patch };
    setAnswers(next);
    setTextDraft("");
    if (currentQ < quizQueue.length - 1) setCurrentQ(currentQ + 1);
    else showResults(next);
  };
  const moreQuestions = QUIZ_QUESTIONS.filter((q) => !q.core && !answers[q.id]).length;

  // ── 専門家への相談（2パターン） ──
  // かんたん相談：最低限だけ聞いてすぐ相談（入力が面倒な人向け）
  // くわしく相談：事前に情報を入れてから相談（面談1回で話が進む）
  // どちらも「制度を1つ決めてから相談」にはしない。その制度が対象外だったときに話が終わってしまうので、
  // やりたいこと・地域を伝えて、合う制度を専門家が探す形にする。
  // options があれば選択肢をタップ、type "pref" は県＋市町村、どちらも無ければ自由記入。
  const CONSULT_MUST = [
    {
      key: "goal",
      label: "今回、何をしたいですか？",
      why: "💡 やりたいことに合う制度を、専門家が国・県・市町村から探します",
      options: quizOptions("purpose"),
    },
    {
      key: "where",
      type: "pref",
      label: "農業をされている都道府県・市町村は？",
      why: "💡 県や市町村の制度は地域ごとに違うので、最初に確認します。細かい住所は不要です",
    },
    {
      key: "contract",
      label: "⚠️ その投資は、まだ契約・発注・購入していませんか？",
      why: "⚠️ 購入・契約済みの場合、多くの補助金は申請できません。正直に教えてください",
      options: [...quizOptions("contract_status"), "買うもの・工事の予定はない"],
    },
  ];

  const CONSULT_DETAIL = [
    {
      key: "invest",
      label: "具体的に、何を買う・何をする予定ですか？",
      why: "💡 どの制度が使えるかを判断する材料になります",
      placeholder: "例：10年使ったトラクターを新型に買い替えたい・ビニールハウスを建てたい",
    },
    {
      key: "estimate",
      label: "見積書（金額が分かる書類）はありますか？",
      why: "💡 見積書は申請の必須書類です。まだ無くても、あとから取れば大丈夫です",
      options: quizOptions("estimate_ready"),
    },
    {
      key: "farmer_type",
      label: "個人ですか、法人ですか？",
      why: "💡 個人か法人かで、使える制度が変わります",
      options: quizOptions("farmer_type"),
    },
    {
      key: "certified",
      label: "認定農業者や認定新規就農者の資格はありますか？",
      why: "💡 多くの大型補助金の要件になります。「わからない」でも大丈夫です",
      options: quizOptions("certification"),
    },
    {
      key: "crop",
      label: "主に作っているもの・栽培品目を教えてください",
      why: "💡 品目ごとに補助金が用意されている地域があります",
      placeholder: "例：畑作（じゃがいも・玉ねぎ） / 酪農 / 施設野菜（トマト）",
    },
    {
      key: "workers",
      label: "農業に従事している人数は？（ご家族・従業員を含む）",
      why: "💡 規模によって使える制度が違うことがあります",
      options: quizOptions("workers"),
    },
    {
      key: "yield_now",
      label: "いまの生産量はどのくらいですか？（ざっくりでOK）",
      why: "💡 事業計画の出発点になる数字です。おおよそで構いません",
      placeholder: "例：じゃがいも 年間およそ80トン / 10aあたり3トン / わからない",
    },
    {
      key: "reason",
      label: "いま、いちばん困っていること・課題は何ですか？",
      why: "💡 これが事業計画の中心になります。数字があるとより伝わります",
      placeholder: "例：古い農機で作業に年300時間かかる / 収穫期に人手が足りない",
    },
    {
      key: "equipment",
      label: "導入したい機械・設備・工事は何ですか？",
      why: "💡 スマート農業などの制度では、何を入れるかで対象が決まります",
      placeholder: "例：自動操舵つきトラクター / 選果機 / 抜根して整地",
    },
    {
      key: "solution",
      label: "それで、課題はどう良くなりそうですか？",
      why: "💡 「入れると何が変わるか」を一言で。専門家が文章に整えます",
      placeholder: "例：作業時間が3分の1になる / 1人でも収穫できるようになる",
    },
    {
      key: "growth",
      label: "それによって、生産量や面積はどのくらい増えそうですか？",
      why: "💡 わからなければ空欄で大丈夫です。農地を広げる場合は、面積から専門家が計算できます",
      placeholder: "例：2ha → 3ha に広げたい / 収量が1〜2割増えそう / わからない",
    },
    {
      key: "timeline",
      label: "いつまでに必要ですか？",
      why: "💡 申請のスケジュールを逆算するために使います",
      placeholder: "例：来年の雪解けまでに / 来年3月の作付けまでに / 特に期限はない",
    },
    {
      key: "selfpay",
      label: "補助金が出るまでの間、自己資金や借入で立て替えられそうですか？",
      why: "💡 補助金は後払いが多く、先に自分で支払う必要があります。資金のめどが立たずに止まる例が多いので、先に確認します",
      placeholder: "例：ある程度用意できる / 難しい・融資も考えたい / わからない",
    },
    {
      key: "blue_tax",
      label: "青色申告をしていますか？",
      why: "💡 収入保険・経営安定系の制度の要件になることが多いです",
      options: quizOptions("blue_tax"),
    },
    {
      key: "experience",
      label: "農業を始めて何年になりますか？",
      why: "💡 就農5年以内だと使える制度の幅が広がります",
      options: quizOptions("farm_experience"),
    },
    {
      key: "past",
      label: "過去に農業の補助金を受けたことはありますか？",
      why: "💡 同じ機械・同じ経費での重複申請はできないので確認します",
      placeholder: "例：ない / ○年前に○○補助金を使った / わからない",
    },
    {
      key: "question",
      label: "専門家に特に確認したいことはありますか？",
      why: "💡 何でも書いてください。初回の面談で優先して答えます",
      placeholder: "例：自分の状況で本当に使えるか確認したい / 費用がいくらかかるか知りたい",
    },
    {
      key: "name",
      label: "お名前・農場名（連絡用）",
      why: "💡 入力しなくてもシートは作れます",
      placeholder: "例：田中 太郎 / 田中農場",
    },
  ];
  const CONSULT_ALL = [...CONSULT_MUST, ...CONSULT_DETAIL];

  const generateConsultSheet = (d, mode) => {
    const row = (label, v) => (v ? `・${label}: ${v}` : "");
    const block = (title, rows) => {
      const body = rows.filter(Boolean);
      return body.length ? ["", `【${title}】`, ...body] : [];
    };
    const refs = d._refs || [];
    const sheet = [
      "■ 農援 補助金相談シート（専門家への事前共有）",
      `作成日時: ${new Date().toLocaleString("ja-JP")}`,
      `相談の種類: ${mode === "detail" ? "くわしく相談（事前に情報を入力）" : "かんたん相談（最低限の入力）"}`,
      ...block("やりたいこと・地域", [
        row("やりたいこと", d.goal),
        row("地域", d.where),
        row("契約・発注の状況", d.contract),
      ]),
      ...block("経営のこと", [
        row("経営のかたち", d.farmer_type),
        row("認定資格", d.certified),
        row("作っているもの・品目", d.crop),
        row("従事している人数", d.workers),
        row("青色申告", d.blue_tax),
        row("農業の経験", d.experience),
      ]),
      ...block("計画のこと（事業計画の材料）", [
        row("買うもの・すること", d.invest),
        row("見積書", d.estimate),
        row("いまの生産量", d.yield_now),
        row("困っていること・課題", d.reason),
        row("導入したい機械・設備", d.equipment),
        row("どう良くなりそうか", d.solution),
        row("増えそうな生産量・面積", d.growth),
        row("必要な時期", d.timeline),
        row("立て替えのめど", d.selfpay),
        row("過去の補助金", d.past),
      ]),
      ...block("気になっている制度（参考）", [
        ...refs.map((r) => `・${r}`),
        refs.length ? "※ この制度に限りません。やりたいことに合う制度（国・県・市町村）があれば提案をお願いします。" : "",
      ]),
      ...block("専門家への質問", [d.question]),
      ...block("連絡先", [row("お名前・農場名", d.name)]),
      "",
      "※ このシートは農家さんご自身がコピーして使うものです。自動送信はされません。",
      "※ 最終判断は行政書士または各事務局にご確認ください。",
      "※ 契約・発注・購入は、交付決定の前にしないでください（事前着手は対象外になります）。",
    ].join("\n");
    setConsultSheet(sheet);
  };

  // mode: quick＝かんたん相談 ／ detail＝くわしく相談。back＝「戻る」で帰る画面
  const startConsult = (mode, back, carry = {}) => {
    // すでに分かっていること（選んだやりたいこと・地域・診断の回答）は聞き直さない
    const pre = {
      goal:        (goal && goal.label) || answers.purpose || "",
      where:       whereText,
      contract:    answers.contract_status || "",
      estimate:    answers.estimate_ready || "",
      farmer_type: answers.farmer_type || "",
      certified:   answers.certification || "",
      crop:        [answers.main_crop, answers.crop_items].filter(Boolean).join("／"),
      workers:     answers.workers || "",
      blue_tax:    answers.blue_tax || "",
      experience:  answers.farm_experience || "",
      // 参考として添える制度：制度のページから来た人はその制度、診断を済ませた人は相性の高かった上位3件
      _refs: (back === "detail" && selected ? [selected] : matched.slice(0, 3)).map((s) => `${s.name}（${s.source || "国"}）`),
    };
    Object.keys(carry).forEach((k) => { if (carry[k]) pre[k] = carry[k]; });
    const queue = (mode === "detail" ? CONSULT_ALL : CONSULT_MUST).filter((q) => !pre[q.key]).map((q) => q.key);
    setConsultMode(mode);
    setConsultBack(back);
    setConsultData(pre);
    setConsultQueue(queue);
    setConsultStep(0);
    setTextDraft("");
    setWhereDraft({ pref: profile.pref || "", city: profile.city || "" });
    setSheetCopied(false);
    setConsultSheet("");
    // 聞くことが残っていなければ、そのままシートを作る
    if (queue.length === 0) generateConsultSheet(pre, mode);
    setPhase("consult");
  };

  const copyConsultSheet = () => {
    // 予約ボタンからも呼ぶ。コピーできない端末でも予約ページには進めるよう、失敗は握りつぶす
    try {
      navigator.clipboard.writeText(consultSheet).then(() => {
        setSheetCopied(true);
        setTimeout(() => setSheetCopied(false), 2500);
      }).catch(() => {});
    } catch { /* クリップボードが使えない */ }
  };

  // ── 書類生成 ──
  const generateDoc = async () => {
    const text = await call({
      messages: [{
        role: "user",
        content: `「${selected.name}」の申請準備のための事業計画書の骨子を作成してください。
申請者：${applyData.name}、住所：${applyData.address}、農業規模：${applyData.scale}
用途：${applyData.purpose}、概算費用：${applyData.cost}
簡潔な見出しと内容の概要、注意点を含めてください。実際の申請は窓口確認が必要な旨も記載。`,
      }],
    });
    setDoc(text);
    setApplyStep(99);
  };

  const skipBtnStyle = { width:"100%", background:"none", border:"none", color:"#888", fontSize:"0.82rem", marginTop:"0.5rem", cursor:"pointer", padding:"0.4rem" };

  // ── 地域（県・市町村）を聞く画面 ──
  if (phase === "where") return (
    <div className="screen">
      <button className="back-btn" onClick={() => setPhase("list")}>← 戻る</button>
      <div className="q-icon">📍</div>
      <h2 className="q-text" style={{ marginBottom:"0.6rem" }}>どちらで農業をされていますか？</h2>
      <p className="sub" style={{ marginBottom:"1rem", textAlign:"center" }}>
        都道府県と市町村がわかると、国の制度に加えて、<br />その地域の制度を先にお見せできます。<br />細かい住所は不要です。
      </p>
      <div style={{ display:"flex", flexDirection:"column", gap:"0.6rem" }}>
        <PrefFields value={whereDraft} onChange={setWhereDraft} />
      </div>
      <button
        className="primary-btn"
        disabled={!whereDraft.pref}
        onClick={() => { saveProfile({ pref: whereDraft.pref, city: (whereDraft.city || "").trim(), asked: true }); setPhase("list"); }}
      >
        この地域の制度を見る →
      </button>
      <button style={skipBtnStyle} onClick={() => { saveProfile({ ...profile, asked: true }); setPhase("list"); }}>
        あとで入れる（全国の制度を見る）
      </button>
    </div>
  );

  // ── 専門家への相談画面 ──
  if (phase === "consult") {
    const leaveConsult = () => { setPhase(consultBack); setConsultSheet(""); setConsultStep(0); };

    // シート完成
    if (consultSheet !== "") {
      const lineUrl = lineEntryUrl("hojokin-soudan", { goal: goal ? goal.category : "", pref: profile.pref });
      return (
        <div className="screen">
          <button className="back-btn" onClick={leaveConsult}>← 戻る</button>
          <div style={{ background:"linear-gradient(135deg,#1a4a2e,#2d6a4f)", borderRadius:14, padding:"1.1rem", marginBottom:"1rem", color:"#fff" }}>
            <div style={{ fontSize:"0.78rem", color:"#a7f3c0", marginBottom:"0.3rem" }}>✅ 相談の準備ができました</div>
            <h2 style={{ fontSize:"1.1rem", fontWeight:800, margin:0 }}>専門家への相談シートが完成しました</h2>
          </div>

          <ExpertCard />

          {TIMEREX_URL && (
            <>
              <a
                href={TIMEREX_URL} target="_blank" rel="noreferrer"
                onClick={copyConsultSheet}
                style={{ display:"block", textAlign:"center", background:"#2e7d32", color:"#fff", fontWeight:800, fontSize:"0.95rem", borderRadius:10, padding:"0.9rem", textDecoration:"none", marginBottom:"0.35rem" }}
              >
                📅 相談の日時を選ぶ（無料）
              </a>
              <p style={{ fontSize:"0.74rem", color:"#666", textAlign:"center", marginBottom:"0.9rem", lineHeight:1.6 }}>
                ボタンを押すと相談シートがコピーされます。<br/>予約画面のコメント欄に貼り付けてください。
              </p>
            </>
          )}

          <div style={{ background:"#f5f5f5", borderRadius:12, padding:"1rem", marginBottom:"0.75rem", fontSize:"0.78rem", color:"#333", whiteSpace:"pre-wrap", lineHeight:1.8, maxHeight:"34vh", overflowY:"auto" }}>
            {consultSheet}
          </div>
          <button
            onClick={copyConsultSheet}
            style={{ width:"100%", background: sheetCopied ? "#2e7d32" : "#1a4a2e", color:"#fff", fontWeight:800, fontSize:"0.95rem", borderRadius:10, padding:"0.9rem", border:"none", cursor:"pointer", marginBottom:"0.75rem" }}
          >
            {sheetCopied ? "✅ コピーしました" : "📋 相談シートをコピーする"}
          </button>

          {lineUrl && (
            <a
              href={lineUrl} target="_blank" rel="noreferrer"
              style={{ display:"block", textAlign:"center", background:"#06c755", color:"#fff", fontWeight:800, fontSize:"0.93rem", borderRadius:10, padding:"0.85rem", textDecoration:"none", marginBottom:"0.75rem" }}
            >
              💬 LINEで相談をつづける
            </a>
          )}

          {!TIMEREX_URL && !lineUrl && (
            <p style={{ fontSize:"0.75rem", color:"#888", textAlign:"center", lineHeight:1.7 }}>
              このシートをLINE・メール・電話でそのまま行政書士にお送りください。<br/>
              事前情報が揃っているため、初回面談がスムーズになります。
            </p>
          )}

          {consultMode === "quick" && (
            <button
              onClick={() => startConsult("detail", consultBack, consultData)}
              style={{ width:"100%", background:"#fff", border:"1px solid #ddd", color:"#555", fontSize:"0.82rem", borderRadius:10, padding:"0.65rem", cursor:"pointer", marginBottom:"0.75rem" }}
            >
              ✏️ もう少し詳しく伝える（任意・面談が早く進みます）
            </button>
          )}

          {/* 申請の途中・最後で止まりやすい理由（先に知っておいてもらう） */}
          <div style={{ background:"#fff8e1", borderRadius:12, padding:"0.9rem", fontSize:"0.78rem", color:"#333", lineHeight:1.8 }}>
            <div style={{ fontWeight:700, fontSize:"0.82rem", color:"#e65100", marginBottom:"0.3rem" }}>⚠️ 補助金で止まりやすい3つのこと</div>
            ・交付が決まる前に、契約・発注・購入をしない<br/>
            ・見積書・請求書・領収書・振込の記録は、全部とっておく<br/>
            ・買う機械や台数を変えたくなったら、買う前に必ず相談する
          </div>
        </div>
      );
    }

    // 質問
    const cq = CONSULT_ALL.find((q) => q.key === consultQueue[consultStep]);
    const isLast = consultStep === consultQueue.length - 1;
    const isMust = CONSULT_MUST.some((q) => q.key === cq.key);
    const answerConsult = (patch) => {
      const next = { ...consultData, ...patch };
      setConsultData(next);
      setTextDraft("");
      if (isLast) generateConsultSheet(next, consultMode);
      else setConsultStep(consultStep + 1);
    };
    const goBack = () => {
      if (consultStep === 0) { leaveConsult(); return; }
      setTextDraft(consultData[consultQueue[consultStep - 1]] || "");
      setConsultStep(consultStep - 1);
    };

    return (
      <div className="screen" style={{ padding:"0" }}>
        <div style={{ background:"#1a4a2e", padding:"0.75rem 1rem" }}>
          <div style={{ display:"flex", alignItems:"center", gap:"0.5rem" }}>
            <button onClick={goBack}
              style={{ background:"none", border:"1px solid rgba(255,255,255,0.3)", color:"#a7f3c0", borderRadius:6, padding:"0.2rem 0.6rem", fontSize:"0.72rem", cursor:"pointer" }}>
              ← 戻る
            </button>
            <div style={{ fontSize:"0.78rem", color:"#fff", fontWeight:700 }}>
              👨‍💼 専門家への相談（{consultMode === "detail" ? "くわしく" : "かんたん"}）
            </div>
            <div style={{ marginLeft:"auto", fontSize:"0.72rem", color:"#a7f3c0" }}>{consultStep + 1} / {consultQueue.length}</div>
          </div>
        </div>

        <div style={{ padding:"1rem" }}>
          {/* 免責メモ */}
          <div style={{ background:"#f9fbe7", border:"1px solid #c5e1a5", borderRadius:10, padding:"0.6rem 0.85rem", marginBottom:"0.9rem", fontSize:"0.75rem", color:"#558b2f" }}>
            📋 答えた内容は<strong>相談シート</strong>にまとまります。自動送信はしません。
          </div>

          {/* 進捗バー */}
          <div style={{ background:"#e0e0e0", borderRadius:99, height:5, marginBottom:"1rem" }}>
            <div style={{ background:"#2e7d32", borderRadius:99, height:5, width:`${((consultStep + 1) / consultQueue.length) * 100}%`, transition:"width 0.3s" }} />
          </div>

          {/* なぜこれを聞くか */}
          <div style={{ fontSize:"0.75rem", color:"#555", background:"#fafafa", borderRadius:8, padding:"0.5rem 0.75rem", marginBottom:"0.75rem" }}>
            {cq.why}
          </div>

          <h3 style={{ fontSize:"1rem", fontWeight:700, color:"#1a4a2e", marginBottom:"0.75rem", lineHeight:1.5 }}>
            {cq.label}
            {!isMust && <span style={{ fontSize:"0.72rem", color:"#888", fontWeight:400, marginLeft:"0.5rem" }}>（任意）</span>}
          </h3>

          {cq.options ? (
            <div className="options">
              {cq.options.map((opt) => (
                <button key={opt} className="option-btn" onClick={() => answerConsult({ [cq.key]: opt })}>{opt}</button>
              ))}
            </div>
          ) : cq.type === "pref" ? (
            <>
              <div style={{ display:"flex", flexDirection:"column", gap:"0.6rem" }}>
                <PrefFields value={whereDraft} onChange={setWhereDraft} />
              </div>
              <button
                className="primary-btn"
                disabled={!whereDraft.pref}
                onClick={() => {
                  const city = (whereDraft.city || "").trim();
                  saveProfile({ pref: whereDraft.pref, city, asked: true });
                  answerConsult({ where: `${whereDraft.pref}${city}` });
                }}
              >
                {isLast ? "✅ 相談シートを作成する" : "次へ →"}
              </button>
            </>
          ) : (
            <>
              <textarea
                rows={3}
                value={textDraft}
                onChange={(e) => setTextDraft(e.target.value)}
                placeholder={cq.placeholder}
                style={{ width:"100%", border:"1px solid #ddd", borderRadius:10, padding:"0.75rem", fontSize:"0.9rem", lineHeight:1.6, resize:"none", boxSizing:"border-box", marginBottom:"0.25rem" }}
              />
              <button
                className="primary-btn" style={{ marginTop:"0.5rem" }}
                onClick={() => answerConsult(textDraft.trim() ? { [cq.key]: textDraft.trim() } : {})}
              >
                {isLast ? "✅ 相談シートを作成する" : "次へ →"}
              </button>
            </>
          )}

          {/* 任意の質問は飛ばせる。途中でやめてシートを作ることもできる */}
          {!isMust && !isLast && (
            <button style={skipBtnStyle} onClick={() => answerConsult({})}>スキップ →</button>
          )}
          {!isMust && (
            <button
              onClick={() => generateConsultSheet(textDraft.trim() && !cq.options ? { ...consultData, [cq.key]: textDraft.trim() } : consultData, consultMode)}
              style={{ width:"100%", background:"none", border:"1px solid #ddd", color:"#555", fontSize:"0.82rem", borderRadius:10, padding:"0.65rem", cursor:"pointer", marginTop:"0.5rem" }}
            >
              ここまでの内容で相談シートを作る →
            </button>
          )}
        </div>
      </div>
    );
  }

  // ── 申請画面 ──
  if (phase === "apply") return (
    <div className="screen">
      <button className="back-btn" onClick={() => { setPhase("detail"); setApplyStep(0); }}>← 戻る</button>
      <h2 className="screen-title">📝 申請書類の作成</h2>
      <p className="sub">{selected.name}</p>

      {applyStep < APPLY_FIELDS.length && (
        <>
          <div className="step-bar">STEP {applyStep + 1} / {APPLY_FIELDS.length}</div>
          <label className="field-label">{APPLY_FIELDS[applyStep].label}</label>
          <input
            className="field-input"
            placeholder={APPLY_FIELDS[applyStep].ph}
            value={applyData[APPLY_FIELDS[applyStep].key] || ""}
            onChange={(e) => setApplyData({ ...applyData, [APPLY_FIELDS[applyStep].key]: e.target.value })}
          />
          <button
            className="primary-btn"
            disabled={!applyData[APPLY_FIELDS[applyStep].key] || loading}
            onClick={() => applyStep < APPLY_FIELDS.length - 1 ? setApplyStep(applyStep + 1) : generateDoc()}
          >
            {applyStep < APPLY_FIELDS.length - 1 ? "次へ →" : loading ? "生成中..." : "書類を自動生成 ✨"}
          </button>
        </>
      )}

      {applyStep === 99 && (
        <>
          <div className="doc-box"><pre className="doc-pre">{doc}</pre></div>
          <div className="notice">⚠️ これは参考書類です。実際の申請は市町村農政担当窓口にご相談ください。</div>
          <a href={selected.applyUrl} target="_blank" rel="noreferrer" className="link-btn">🔗 農林水産省 公式サイト</a>
          <BakrinBanner />
        </>
      )}
    </div>
  );

  // ── 詳細画面 ──
  if (phase === "detail") {
    const c = CATEGORY_COLORS[selected.category] || {};
    const diff = NATIONAL_SOURCES.includes(selected.source)
      ? (DIFFICULTY[selected.category] || { label:"★★☆ 中程度", color:"#f57f17" })
      : { label:"★☆☆ 窓口確認で申請", color:"#2e7d32" };
    const bonusPts  = BONUS_POINTS[selected.category] || [];
    const todos     = TODO_LIST[selected.category]   || [];
    const applyMeth = APPLY_METHOD[selected.category] || { level:"窓口に確認", color:"#555", icon:"🏛️", desc:"市区町村農政課または農協にご相談ください。" };
    const docVol    = DOC_VOLUME[selected.category] || "中";
    const timeline  = TIMELINE[selected.category]   || [];
    const combos    = COMBO_SUGGESTIONS[selected.category] || [];

    // 本文中の専門用語をハイライト
    const TermText = ({ text }) => {
      const parts = text.split(/(認定農業者|認定新規就農者|gBizID|事前着手|青色申告|地域計画|採択率|補助率|JAバンク|成功報酬)/g);
      return <>{parts.map((p, i) => TERMS[p]
        ? <span key={i} style={{ borderBottom:"1px dashed #1565c0", color:"#1565c0", cursor:"pointer" }} onClick={() => setOpenTerm(openTerm === p ? null : p)}>{p}</span>
        : <span key={i}>{p}</span>
      )}</>;
    };

    return (
      <div className="screen">
        <button className="back-btn" onClick={() => setPhase(matched.length ? "results" : "list")}>← 戻る</button>
        <div className="detail-icon">{selected.icon}</div>
        <h2 className="screen-title">{selected.name}</h2>

        {/* バッジ行 */}
        <div style={{ display:"flex", gap:"0.4rem", flexWrap:"wrap", marginBottom:"0.5rem" }}>
          <span className="badge" style={{ background: c.bg, color: c.text }}>{selected.category}</span>
          {selected.matchLabel && <span style={mL[selected.matchLabel]}>{selected.matchLabel} {selected.matchLabel === "◎" ? "ぴったり" : selected.matchLabel === "○" ? "合いそう" : "参考"}</span>}
        </div>
        {selected.source && (
          <p style={{ fontSize:"0.78rem", color:"#666", margin:"0 0 0.5rem" }}>📌 出典: {selected.source}</p>
        )}

        {/* 通りやすさチェック（診断回答との突合内訳） */}
        {selected.checks?.length > 0 && (
          <div style={{ background:"#f1f8e9", border:"1px solid #aed581", borderRadius:10, padding:"0.75rem", marginBottom:"0.75rem" }}>
            <div style={{ fontWeight:700, fontSize:"0.82rem", color:"#33691e", marginBottom:"0.4rem" }}>✅ 通りやすさチェック（あなたの回答との相性）</div>
            {selected.checks.map((ch, i) => (
              <div key={i} style={{ display:"flex", justifyContent:"space-between", fontSize:"0.78rem", padding:"0.15rem 0", color:"#444" }}>
                <span>{ch.t}</span>
                <span style={{ fontWeight:700, color: ch.ok === "◎" ? "#2e7d32" : ch.ok === "○" ? "#f57f17" : "#c62828" }}>{ch.ok}</span>
              </div>
            ))}
            <div style={{ fontSize:"0.68rem", color:"#888", marginTop:"0.4rem" }}>※あくまで診断回答との相性の目安です。最終的な可否は公募要領・窓口でご確認ください。</div>
          </div>
        )}

        {/* 3つのスペック */}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"0.4rem", marginBottom:"0.9rem" }}>
          <div style={{ background:"#fafafa", border:"1px solid #eee", borderRadius:10, padding:"0.6rem", textAlign:"center" }}>
            <div style={{ fontSize:"0.65rem", color:"#888", marginBottom:"0.2rem" }}>申請難易度</div>
            <div style={{ fontSize:"0.78rem", fontWeight:700, color: diff.color }}>{diff.label}</div>
          </div>
          <div style={{ background:"#fafafa", border:"1px solid #eee", borderRadius:10, padding:"0.6rem", textAlign:"center" }}>
            <div style={{ fontSize:"0.65rem", color:"#888", marginBottom:"0.2rem" }}>書類の量</div>
            <div style={{ fontSize:"0.85rem", fontWeight:700, color: DOC_COLOR[docVol] }}>{docVol}</div>
          </div>
          <div style={{ background:"#fafafa", border:"1px solid #eee", borderRadius:10, padding:"0.6rem", textAlign:"center" }}>
            <div style={{ fontSize:"0.65rem", color:"#888", marginBottom:"0.2rem" }}>申請窓口</div>
            <div style={{ fontSize:"0.72rem", fontWeight:700, color: applyMeth.color }}>{applyMeth.icon}</div>
          </div>
        </div>

        {/* 申請方法 */}
        <div style={{ background:"#f9f9f9", border:`1px solid ${applyMeth.color}`, borderRadius:10, padding:"0.75rem", marginBottom:"0.75rem" }}>
          <div style={{ fontWeight:700, fontSize:"0.82rem", color: applyMeth.color, marginBottom:"0.3rem" }}>{applyMeth.icon} {applyMeth.level}</div>
          <div style={{ fontSize:"0.78rem", color:"#555" }}>{applyMeth.desc}</div>
        </div>

        <p className="sub" style={{ margin: "0 0 0.75rem" }}><TermText text={selected.summary} /></p>
        {openTerm && (
          <div style={{ background:"#e3f2fd", border:"1px solid #1565c0", borderRadius:10, padding:"0.75rem", marginBottom:"0.75rem", fontSize:"0.8rem" }}>
            <strong style={{ color:"#1565c0" }}>📖 {openTerm}とは？</strong><br/>{TERMS[openTerm]}
          </div>
        )}

        <div className="meta-grid">
          <div className="meta-card"><div className="meta-label">💰 上限金額</div><div className="meta-val">{selected.maxAmount}</div></div>
          <div className="meta-card"><div className="meta-label">📅 申請期限</div><div className="meta-val">{selected.deadline}</div></div>
        </div>

        {/* 申請タイムライン */}
        {timeline.length > 0 && (
          <div style={{ background:"#f3e5f5", borderRadius:12, padding:"0.9rem", marginBottom:"0.75rem" }}>
            <div style={{ fontWeight:700, fontSize:"0.85rem", color:"#6a1b9a", marginBottom:"0.5rem" }}>📅 申請〜採択のおおよそのスケジュール</div>
            {timeline.map((t, i) => <div key={i} style={{ fontSize:"0.8rem", color:"#333", marginBottom:"0.3rem", display:"flex", gap:"0.3rem" }}><span style={{ minWidth:"1rem" }}>{i+1}.</span><span>{t}</span></div>)}
            <div style={{ fontSize:"0.72rem", color:"#888", marginTop:"0.4rem" }}>※目安です。実際の期間は補助金の公募時期により異なります</div>
          </div>
        )}

        {/* 採択率を上げるポイント */}
        {bonusPts.length > 0 && (
          <div style={{ background:"#e3f2fd", borderRadius:12, padding:"0.9rem", marginBottom:"0.75rem" }}>
            <div style={{ fontWeight:700, fontSize:"0.85rem", color:"#1565c0", marginBottom:"0.5rem" }}>🎯 採択率を上げるポイント</div>
            {bonusPts.map((p, i) => <div key={i} style={{ fontSize:"0.8rem", color:"#333", marginBottom:"0.25rem" }}>{p}</div>)}
          </div>
        )}

        {/* 今すぐやること */}
        {todos.length > 0 && (
          <div style={{ background:"#fff8e1", borderRadius:12, padding:"0.9rem", marginBottom:"0.75rem" }}>
            <div style={{ fontWeight:700, fontSize:"0.85rem", color:"#e65100", marginBottom:"0.5rem" }}>⚡ 今すぐやること</div>
            {todos.map((t, i) => <div key={i} style={{ fontSize:"0.8rem", color:"#333", marginBottom:"0.25rem" }}>{t}</div>)}
          </div>
        )}

        {/* 組み合わせ可能な補助金 */}
        {combos.length > 0 && (
          <div style={{ background:"#e8eaf6", borderRadius:12, padding:"0.9rem", marginBottom:"0.75rem" }}>
            <div style={{ fontWeight:700, fontSize:"0.85rem", color:"#283593", marginBottom:"0.5rem" }}>🔗 他の補助金との組み合わせ</div>
            {combos.map((c, i) => <div key={i} style={{ fontSize:"0.8rem", color:"#333", marginBottom:"0.25rem" }}>{c}</div>)}
            <div style={{ fontSize:"0.72rem", color:"#888", marginTop:"0.4rem" }}>※重複可否は行政書士または各事務局に必ずご確認ください</div>
          </div>
        )}

        <a href={selected.applyUrl} target="_blank" rel="noreferrer" className="primary-btn"
           style={{ display:"block", textAlign:"center", textDecoration:"none", marginBottom:"0.75rem" }}>
          🔗 公式サイト・詳細ページを見る
        </a>
        <button className="primary-btn" style={{ background:"#fff", color:"#2e7d32", border:"2px solid #2e7d32", marginBottom:"0.75rem" }}
                onClick={() => { setPhase("apply"); setApplyStep(0); }}>
          📝 申請書類の骨子を作成する
        </button>

        {/* 行政書士相談 */}
        <div style={{ background:"#f1f8e9", borderRadius:12, padding:"1rem", marginTop:"0.5rem" }}>
          <div style={{ fontWeight:700, fontSize:"0.85rem", color:"#2e7d32", marginBottom:"0.5rem" }}>👨‍💼 提携行政書士に相談する</div>
          <p style={{ fontSize:"0.8rem", color:"#555", marginBottom:"0.6rem", lineHeight:1.6 }}>
            ① AIが農家さんの情報を整理<br/>
            ② 行政書士が書類作成・申請をサポート<br/>
            ③ 採択後に成功報酬（申請は基本無料相談から）
          </p>
          <p style={{ fontSize:"0.78rem", color:"#555", marginBottom:"0.6rem" }}>
            ✅ この補助金に申請できる可能性があります。最終判断は行政書士へご確認ください。
          </p>
          <button
            onClick={() => startConsult("quick", "detail")}
            style={{ display:"block", width:"100%", textAlign:"center", background:"#2e7d32", color:"#fff", fontWeight:800, fontSize:"0.95rem", borderRadius:10, padding:"0.85rem", border:"none", cursor:"pointer", marginBottom:"0.5rem" }}
          >
            👨‍💼 かんたん相談（最低限の入力ですぐ相談） →
          </button>
          <button
            onClick={() => startConsult("detail", "detail")}
            style={{ display:"block", width:"100%", textAlign:"center", background:"#fff", color:"#2e7d32", fontWeight:700, fontSize:"0.9rem", borderRadius:10, padding:"0.75rem", border:"2px solid #2e7d32", cursor:"pointer" }}
          >
            ✏️ くわしく相談（事前に情報を入れる） →
          </button>
          <p style={{ fontSize:"0.72rem", color:"#555", textAlign:"center", marginTop:"0.5rem", lineHeight:1.6 }}>
            この制度が合わなかった場合も、やりたいことに合う別の制度を専門家が探します。
          </p>
          <p style={{ fontSize:"0.7rem", color:"#888", textAlign:"center", marginTop:"0.4rem" }}>
            ※ 申請できる保証はありません。事前に必ずご確認ください。
          </p>
        </div>
      </div>
    );
  }

  // ── 診断の質問画面 ──
  if (phase === "quiz") {
    const q = QUIZ_QUESTIONS.find((x) => x.id === quizQueue[currentQ]);
    const back = () => {
      setTextDraft("");
      if (currentQ > 0) setCurrentQ(currentQ - 1);
      else setPhase(!q.core && matched.length ? "results" : "list");
    };
    return (
      <div className="screen">
        <button className="back-btn" onClick={back}>← 戻る</button>
        <div className="progress-wrap">
          <div className="progress-track">
            <div className="progress-bar" style={{ width: `${((currentQ + 1) / quizQueue.length) * 100}%` }} />
          </div>
          <span className="progress-label">{currentQ + 1} / {quizQueue.length}</span>
        </div>
        <div className="q-icon">{q.icon}</div>
        <h2 className="q-text" style={q.hint ? { marginBottom:"0.5rem" } : undefined}>{q.question}</h2>
        {q.hint && <p className="sub" style={{ textAlign:"center", marginBottom:"1rem" }}>{q.hint}</p>}

        {q.type === "pref" ? (
          <>
            <div style={{ display:"flex", flexDirection:"column", gap:"0.6rem" }}>
              <PrefFields value={whereDraft} onChange={setWhereDraft} />
            </div>
            <button
              className="primary-btn"
              disabled={!whereDraft.pref}
              onClick={() => {
                const city = (whereDraft.city || "").trim();
                saveProfile({ pref: whereDraft.pref, city, asked: true });
                handleAnswer({ prefecture: whereDraft.pref, city });
              }}
            >
              次へ →
            </button>
            <button style={skipBtnStyle} onClick={() => handleAnswer({})}>わからない・あとで →</button>
          </>
        ) : q.type === "text" ? (
          <>
            <input
              className="field-input"
              placeholder={q.placeholder}
              value={textDraft}
              onChange={(e) => setTextDraft(e.target.value)}
            />
            <button className="primary-btn" onClick={() => handleAnswer(textDraft.trim() ? { [q.id]: textDraft.trim() } : {})}>
              次へ →
            </button>
            <button style={skipBtnStyle} onClick={() => handleAnswer({})}>スキップ →</button>
          </>
        ) : (
          <div className="options">
            {q.options.map((opt) => (
              <button key={opt} className="option-btn" onClick={() => handleAnswer({ [q.id]: opt })}>{opt}</button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ── 診断結果画面 ──
  if (phase === "results") {
    const TOP_N = 5;
    // 県の制度（相性◎○）と国の制度（上位5件）を分けて見せる。残りは「他にも」に畳む
    const localTop    = matched.filter((s) => !isNational(s) && s.matchLabel !== "△");
    const nationalAll = matched.filter(isNational);
    const nationalTop = nationalAll.slice(0, TOP_N);
    const restMatched = [...matched.filter((s) => !isNational(s) && s.matchLabel === "△"), ...nationalAll.slice(TOP_N)];
    const localFirst  = (MATCH_PURPOSE_MAP[answers.purpose] || []).some((c) => LOCAL_FIRST_CATEGORIES.includes(c));
    const lineUrl = lineEntryUrl("hojokin-shindan", { goal: goal ? goal.category : "", pref: answers.prefecture });

    const localBlock = answers.prefecture && (
      <div key="local" style={{ marginBottom:"0.5rem" }}>
        <div style={{ fontSize:"0.82rem", fontWeight:700, color:"#1a4a2e", margin:"0.5rem 0" }}>📍 {answers.prefecture}の制度（{localTop.length}件）</div>
        {localTop.map((s) => <SubsidyCard key={s.id} s={s} onOpen={openDetail} />)}
        {localTop.length === 0 && (
          <p style={{ fontSize:"0.78rem", color:"#666", background:"#fafafa", borderRadius:10, padding:"0.7rem", lineHeight:1.7 }}>
            {answers.prefecture}の制度で、条件に合いそうなものはこのアプリにはまだ載っていません。
            県や市町村の制度は、専門家に相談すると一緒に確認できます。
          </p>
        )}
      </div>
    );
    const nationalBlock = (
      <div key="national" style={{ marginBottom:"0.5rem" }}>
        <div style={{ fontSize:"0.82rem", fontWeight:700, color:"#1a4a2e", margin:"0.5rem 0" }}>🏛 国の制度（相性の高い順・上位{nationalTop.length}件）</div>
        {nationalTop.map((s) => <SubsidyCard key={s.id} s={s} onOpen={openDetail} />)}
      </div>
    );

    return (
      <div className="screen">
        {matched.length > 0 ? (
          <>
            <div style={{ background:"linear-gradient(135deg,#1a4a2e,#2d6a4f)", borderRadius:14, padding:"1rem", marginBottom:"1rem", color:"#fff" }}>
              <div style={{ fontSize:"0.78rem", color:"#a7f3c0", marginBottom:"0.3rem" }}>✅ あなたへのおすすめ補助金</div>
              <h2 style={{ fontSize:"1.2rem", fontWeight:800, margin:"0 0 0.5rem" }}>{localTop.length + nationalTop.length}件に絞り込みました</h2>
              <div style={{ display:"flex", gap:"0.4rem", flexWrap:"wrap" }}>
                <span style={{...mL["◎"], fontSize:"0.72rem"}}>◎ ぴったり</span>
                <span style={{...mL["○"], fontSize:"0.72rem"}}>○ 合いそう</span>
                <span style={{...mL["△"], fontSize:"0.72rem"}}>△ 参考</span>
              </div>
            </div>

            {matched.some(s => s.contractWarning) && (
              <div style={{ background:"#fff3e0", border:"1px solid #ff9800", borderRadius:10, padding:"0.75rem", marginBottom:"0.9rem", fontSize:"0.85rem" }}>
                ⚠️ <strong>ご注意：</strong>契約・発注・購入済みの場合、多くの補助金は<strong>事前着手禁止</strong>のため対象外の可能性があります。
              </div>
            )}

            <ConsultPaths
              title="どれが自分に合うか、迷ったら"
              onQuick={() => startConsult("quick", "results")}
              secondLabel="✏️ くわしく入力してから相談する"
              secondNote="事前に状況を伝えると、1回の面談で話が進みます"
              onSecond={() => startConsult("detail", "results")}
            />

            {moreQuestions > 0 && (
              <button
                onClick={() => startQuiz("more")}
                style={{ width:"100%", background:"#fff", border:"1px solid #2d6a4f", color:"#2d6a4f", borderRadius:10, padding:"0.75rem", fontSize:"0.88rem", fontWeight:700, cursor:"pointer", marginBottom:"0.9rem" }}
              >
                🔍 さらに絞り込む（あと{moreQuestions}問・任意）
              </button>
            )}

            <p style={{ fontSize:"0.72rem", color:"#888", marginBottom:"0.75rem" }}>
              ※ AI診断による参考情報です。申請可否は行政書士または各事務局へご確認ください。
            </p>

            {localFirst ? [localBlock, nationalBlock] : [nationalBlock, localBlock]}

            {/* 他○件 */}
            {restMatched.length > 0 && (
              <div style={{ marginTop:"0.5rem" }}>
                {!showAll ? (
                  <button
                    onClick={() => setShowAll(true)}
                    style={{ width:"100%", background:"#f5f5f5", border:"1px solid #ddd", borderRadius:10, padding:"0.85rem", fontSize:"0.9rem", color:"#555", cursor:"pointer", fontWeight:600 }}
                  >
                    他にも {restMatched.length}件 の候補があります →
                  </button>
                ) : (
                  <>
                    <div style={{ fontSize:"0.78rem", color:"#888", margin:"0.75rem 0 0.5rem", fontWeight:600 }}>その他の候補 ({restMatched.length}件)</div>
                    {restMatched.map(s => <SubsidyCard key={s.id} s={s} onOpen={openDetail} />)}
                    <button
                      onClick={() => setShowAll(false)}
                      style={{ width:"100%", background:"#f5f5f5", border:"1px solid #ddd", borderRadius:10, padding:"0.85rem", fontSize:"0.9rem", color:"#555", cursor:"pointer", marginTop:"0.5rem" }}
                    >
                      ▲ 閉じる
                    </button>
                  </>
                )}
              </div>
            )}

            {/* 窓口持参シート印刷 */}
            <button
              onClick={printSheet}
              style={{ width:"100%", background:"#fff", border:"2px solid #2d6a4f", color:"#2d6a4f", borderRadius:10, padding:"0.8rem", fontSize:"0.9rem", fontWeight:700, cursor:"pointer", margin:"0.9rem 0" }}
            >
              🖨 この結果を印刷して窓口に持っていく
            </button>

            {/* AIおすすめ理由 */}
            {!aiReco && (
              <button className="ai-tip-btn" onClick={getAiReco} disabled={loading} style={{ marginBottom:"0.9rem" }}>
                {loading ? "AIが分析中..." : "🤖 AIに「なぜおすすめか」を聞く"}
              </button>
            )}
            {aiReco && (
              <div className="ai-tip-box" style={{ marginBottom:"0.9rem" }}>
                <div className="ai-tip-header">🌾 農援AIのおすすめ理由</div>
                <p className="ai-tip-text" style={{ whiteSpace:"pre-wrap" }}>{aiReco}</p>
              </div>
            )}

            {/* 新しい制度のお知らせ（農援LINE）。LINEの入口が未設定の間は出ない */}
            {lineUrl && (
              <div style={{ background:"#f0fdf4", border:"1px solid #86efac", borderRadius:12, padding:"0.9rem", marginBottom:"0.9rem" }}>
                <p style={{ fontSize:"0.82rem", color:"#333", lineHeight:1.7, marginBottom:"0.6rem" }}>
                  あなたの地域・作物に合う制度が新しく出たときだけ、LINEでお知らせします（月2〜3回・補助金と農家に役立つ話だけ）
                </p>
                <a
                  href={lineUrl} target="_blank" rel="noreferrer"
                  style={{ display:"block", textAlign:"center", background:"#06c755", color:"#fff", fontWeight:800, fontSize:"0.93rem", borderRadius:10, padding:"0.8rem", textDecoration:"none" }}
                >
                  LINEで通知を受け取る（無料）
                </a>
              </div>
            )}
          </>
        ) : (
          <>
            <h2 className="screen-title">条件に合う補助金が見つかりませんでした</h2>
            <ConsultPaths
              title="載っていない制度が使えることもあります"
              onQuick={() => startConsult("quick", "results")}
              secondLabel="✏️ くわしく入力してから相談する"
              secondNote="事前に状況を伝えると、1回の面談で話が進みます"
              onSecond={() => startConsult("detail", "results")}
            />
          </>
        )}
        <BakrinBanner />
        <button className="back-btn" onClick={() => { setPhase("list"); setAnswers({}); setMatched([]); setCurrentQ(0); setShowAll(false); }}>
          ← 一覧に戻る
        </button>
      </div>
    );
  }

  // ── 一覧画面（デフォルト）──
  // 設備・就農・農地・環境は県の制度を先に、それ以外は国の制度を先に並べる
  const localFirst = filter === "すべて" || LOCAL_FIRST_CATEGORIES.includes(filter);
  const chipStyle = { display:"inline-flex", alignItems:"center", gap:"0.35rem", background:"#fff", border:"1px solid #cfe3d4", borderRadius:99, padding:"0.3rem 0.7rem", fontSize:"0.78rem", color:"#1a4a2e", fontWeight:600, cursor:"pointer" };
  const sectionTitle = { fontSize:"0.82rem", fontWeight:700, color:"#1a4a2e", margin:"0.9rem 0 0.5rem" };

  const localSection = profile.pref && (
    <div key="local">
      <div style={sectionTitle}>📍 {profile.pref}の制度（{localList.length}件）</div>
      {localList.map((s) => <SubsidyCard key={s.id} s={s} onOpen={openDetail} />)}
      {localList.length === 0 && (
        <p style={{ fontSize:"0.78rem", color:"#666", background:"#fafafa", borderRadius:10, padding:"0.7rem", lineHeight:1.7 }}>
          {profile.pref}の{filter === "すべて" ? "" : `「${filter}」の`}制度は、このアプリにはまだ載っていません。
          県や市町村の制度は、専門家に相談すると一緒に確認できます。
        </p>
      )}
      {profile.city && (
        <p style={{ fontSize:"0.74rem", color:"#888", lineHeight:1.7, margin:"0.4rem 0 0" }}>
          ※ {profile.city}の独自の制度は、まだ載せていません。相談シートには市町村名が入るので、専門家が確認しやすくなります。
        </p>
      )}
    </div>
  );
  const nationalSection = (
    <div key="national">
      {profile.pref && <div style={sectionTitle}>🏛 国の制度（{nationalList.length}件）</div>}
      {nationalList.map((s) => <SubsidyCard key={s.id} s={s} onOpen={openDetail} />)}
    </div>
  );

  return (
    <div className="screen">
      <h2 className="screen-title">📋 補助金を探す</h2>

      {/* いま何で絞っているか（やりたいこと・地域）。タップで変えられる */}
      <div style={{ display:"flex", gap:"0.4rem", flexWrap:"wrap", marginBottom:"0.9rem" }}>
        {goal && (
          <button style={chipStyle} onClick={onChangeGoal}>
            {goal.icon} {goal.label} <span style={{ color:"#888", fontWeight:400 }}>変える</span>
          </button>
        )}
        <button
          style={chipStyle}
          onClick={() => { setWhereDraft({ pref: profile.pref || "", city: profile.city || "" }); setPhase("where"); }}
        >
          📍 {whereText || "地域を入れる（地元の制度が先に出ます）"} {whereText && <span style={{ color:"#888", fontWeight:400 }}>変える</span>}
        </button>
      </div>

      <ConsultPaths
        title="制度がたくさんあって迷ったら"
        onQuick={() => startConsult("quick", "list")}
        secondLabel="🔍 質問に答えてもっと絞り込む"
        secondNote="タップで答えるだけ。1分ほどで終わります"
        onSecond={() => startQuiz("core")}
      />

      <div className="filter-row">
        {cats.map((c) => (
          <button key={c} className={`filter-btn ${filter === c ? "active" : ""}`} onClick={() => setFilter(c)}>{c}</button>
        ))}
      </div>

      {localFirst ? [localSection, nationalSection] : [nationalSection, localSection]}
    </div>
  );
}
